import {useMediaQuery} from "@mui/material";
import {theme} from "./index";
import {useLocation} from "react-router-dom";
import {useEffect, useMemo, useRef} from "react";

export const hoverBackground = '#35373f';

export const useIsMobileHook = () => !useMediaQuery(theme.breakpoints.up('md'))

export const useOutsideClick = (callback) => {
    const ref = useRef();

    useEffect(() => {
        const handleClick = (event) => {
            if (ref.current && !ref.current.contains(event.target)) {
                callback();
            }
        };

        document.addEventListener('click', handleClick, true);

        return () => {
            document.removeEventListener('click', handleClick, true);
        };
    }, [ref]);

    return ref;
};

export const useQuery = () => {
    const { search } = useLocation();
    return useMemo(() => new URLSearchParams(search), [search]);
}

export const randomInt = (max) => Math.floor(Math.random() * max)

export const inputPlaceholder = (selected, placeholder) => {
    if (selected == null || selected.length === 0) {
        return placeholder;
    }
    return selected;
}

export function weaponImageName(weapon) {
    return weapon?.name?.toLowerCase().replaceAll(' ', '-').replaceAll('.', '');
}

export const escapeHTML = (html) => {
    return html
        .replaceAll('&', "&amp;")
        .replaceAll('<', "&lt;")
        .replaceAll('>', "&gt;")
        .replaceAll('"', "&quot;")
        .replaceAll("'", "&#039;");
}

export const lowerOffset = {
    popper: {
        modifiers: [
            {
                name: 'offset',
                options: {
                    offset: [0, -7],
                },
            },
        ],
    },
};